import { Component, OnInit } from '@angular/core';
import { DaoService } from '../servicos/dao.service';

/** Uma pessoa que compõe um setor. */
interface Pessoa {
  nome: string;
  funcao: string;
  email: string;
  foto: string;
  origem: string;
  _delay?: number; // atraso (ms) da animação de aparição
}

/** Um setor do organograma e as pessoas a ele vinculadas. */
interface Setor {
  id: string;        // identificador enviado ao serviço
  nome?: string;     // rótulo exibido (quando difere do id)
  grupo: string;     // código do grupo no servidor
  detalhe: string;   // nível de detalhe ('minimo')
  icone: string;     // classe font-awesome
  pessoas: Pessoa[];
  carregando: boolean;
  erro: boolean;
  _delay?: number;   // atraso (ms) da animação de aparição do nó
}

@Component({
  selector: 'app-organizacao',
  templateUrl: './organizacao.component.html',
  styleUrls: ['./organizacao.component.css']
})
export class OrganizacaoComponent implements OnInit {

  /** Atraso base, em ms, entre cada elemento que surge sequencialmente. */
  private readonly PASSO_ANIMACAO = 90;

  /** Setores na ordem informada. */
  setores: Setor[] = [
    { id: 'Superintendencia',               grupo: 'grup_super',       detalhe: 'minimo', icone: 'fa-star',                       pessoas: [], carregando: true, erro: false },
    { id: 'Secretaria da Superintendencia', grupo: 'grup_secretaria',  detalhe: 'minimo', icone: 'fa-clipboard',                  pessoas: [], carregando: true, erro: false },
    { id: 'Financeiro',                     grupo: 'grup_financeiro',   detalhe: 'minimo', icone: 'fa-money',                      pessoas: [], carregando: true, erro: false },
    { id: 'Contabilidade',                  grupo: 'grup_contabilidade', detalhe: 'minimo', icone: 'fa-calculator',               pessoas: [], carregando: true, erro: false },
    { id: 'Beneficios',                     grupo: 'grup_beneficios',   detalhe: 'minimo', icone: 'fa-handshake-o',                pessoas: [], carregando: true, erro: false },
    { id: 'Recursos Humanos',               grupo: 'grup_rh',           detalhe: 'minimo', icone: 'fa-users',                      pessoas: [], carregando: true, erro: false },
    { id: 'Procuradoria',                   grupo: 'grup_adv',          detalhe: 'minimo', icone: 'fa-balance-scale',              pessoas: [], carregando: true, erro: false },
    { id: 'Central de Processamento de Dados', grupo: 'grup_cpd',       detalhe: 'minimo', icone: 'fa-server',                     pessoas: [], carregando: true, erro: false },
    { id: 'Telefone', nome: 'Recepção',     grupo: 'grup_telefonista',  detalhe: 'minimo', icone: 'fa-phone',                      pessoas: [], carregando: true, erro: false },
  ];

  constructor(public dao: DaoService) { }

  ngOnInit() {
    this.carregarTodos();
  }

  /** Carrega cada setor de forma independente para que falhas isoladas não derrubem o organograma. */
  carregarTodos() {
    this.setores.forEach((setor, i) => {
      // o nó do setor entra em cena já escalonado pela sua posição
      setor._delay = i * this.PASSO_ANIMACAO * 2;
      this.carregarSetor(setor, i);
    });
  }

  carregarSetor(setor: Setor, indice: number) {
    setor.carregando = true;
    setor.erro = false;

    const dados = { grupo: setor.grupo, id: setor.id, detalhe: setor.detalhe };

    this.dao.submeter(dados, 'listarPorGrupo').then(res => {
      const lista: Pessoa[] = Array.isArray(res) ? res : [];

      // atraso sequencial das pessoas, encadeado após a entrada do próprio setor
      const base = (setor._delay || 0) + this.PASSO_ANIMACAO;
      lista.forEach((p, j) => {
        p._delay = base + j * this.PASSO_ANIMACAO;
      });

      setor.pessoas = lista;
      setor.carregando = false;
    }).catch(() => {
      setor.pessoas = [];
      setor.carregando = false;
      setor.erro = true;
    });
  }

  /** Reencaminha para o e-mail da pessoa. */
  enviarEmail(email: string) {
    if (email) {
      window.location.assign(`mailto:${email}`);
    }
  }

  /** Tenta recarregar um setor que falhou. */
  recarregar(setor: Setor) {
    this.carregarSetor(setor, this.setores.indexOf(setor));
  }

  /** Apenas a parte local do e-mail (antes do @). */
  usuarioEmail(email: string): string {
    return email ? email.split('@')[0] : '';
  }

  /** trackBy para evitar recriação de nós no *ngFor. */
  trackPorGrupo(_: number, setor: Setor) { return setor.grupo; }
  trackPorEmail(i: number, p: Pessoa) { return p.email || i; }
}
